import React from 'react';
import styled from 'styled-components';

const SectionTitle = ({ title, subtitle, center }) => {
  return (
    <TitleContainer center={center}>
      <Title center={center}>{title}</Title>
      {subtitle && <Subtitle center={center}>{subtitle}</Subtitle>}
    </TitleContainer>
  );
};

const TitleContainer = styled.div`
  margin-bottom: 3rem;
  text-align: ${({ center }) => (center ? 'center' : 'left')};
`;

const Title = styled.h2`
  color: var(--color-tertiary);
  position: relative;
  display: inline-block;
  margin-bottom: 1rem;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 80px;
    height: 3px;
    background-color: var(--color-secondary);
    left: ${({ center }) => (center ? '50%' : '0')};
    transform: ${({ center }) => (center ? 'translateX(-50%)' : 'none')};
  }
`;

const Subtitle = styled.p`
  color: var(--color-tertiary);
  opacity: 0.8;
  max-width: 600px;
  margin: ${({ center }) => (center ? '0 auto' : '0')};
`;

export default SectionTitle; 